import React from "react";
import Layout from "../../components/Layout";
import "./../../styles/member/service.css";
import PricingCard from "../../components/PricingCard";

const Service: React.FC = () => {
  return (
    <Layout>
      <div className="service-page">
        {/* Header */}
        <div className="service-header">
          <div>
            <h2>Gói dịch vụ</h2>
            <p>Chọn và nâng cấp gói dịch vụ để sử dụng nhiều tính năng hơn</p>
          </div>
        </div>
        <div className="service-body">
          <PricingCard />
        </div>
      </div>
    </Layout>
  );
};

export default Service;
